/* tslint:disable */
/* eslint-disable */
/**
 * Selling Partner API for Orders
 * Use the Orders Selling Partner API to programmatically retrieve order information. With this API, you can develop fast, flexible, and custom applications to manage order synchronization, perform order research, and create demand-based decision support tools.   _Note:_ For the JP, AU, and SG marketplaces, the Orders API supports orders from 2016 onward. For all other marketplaces, the Orders API supports orders for the last two years (orders older than this don\'t show up in the response).
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { AddressExtendedFields } from './address-extended-fields.js';

/**
 * The shipping address for the order.
 */
export interface Address {
    /**
     * The name.
     */
    'Name'?: string;
    /**
     * The company name of the recipient.  **Note**: This attribute is only available for shipping address.
     */
    'CompanyName'?: string;
    /**
     * The street address.
     */
    'AddressLine1'?: string;
    /**
     * Additional street address information, if required.
     */
    'AddressLine2'?: string;
    /**
     * Additional street address information, if required.
     */
    'AddressLine3'?: string;
    /**
     * The city.
     */
    'City'?: string;
    /**
     * The county.
     */
    'County'?: string;
    /**
     * The district.
     */
    'District'?: string;
    /**
     * The state or region.
     */
    'StateOrRegion'?: string;
    /**
     * The municipality.
     */
    'Municipality'?: string;
    /**
     * The postal code.
     */
    'PostalCode'?: string;
    /**
     * The country code. A two-character country code, in ISO 3166-1 alpha-2 format.
     */
    'CountryCode'?: string;
    /**
     * The phone number of the buyer.  **Note**:  1. This attribute is only available for shipping address. 2. In some cases, the buyer phone number is suppressed:  a. Phone is suppressed for all `AFN` (fulfilled by Amazon) orders. b. Phone is suppressed for the shipped `MFN` (fulfilled by seller) order when the current date is past the Latest Delivery Date.
     */
    'Phone'?: string;
    'ExtendedFields'?: AddressExtendedFields;
    /**
     * The address type of the shipping address.
     */
    'AddressType'?: AddressAddressTypeEnum;
}

export const AddressAddressTypeEnum = {
    Residential: 'Residential',
    Commercial: 'Commercial',
} as const;

export type AddressAddressTypeEnum = typeof AddressAddressTypeEnum[keyof typeof AddressAddressTypeEnum];


